import React, {useState, useEffect} from 'react';
import {DatePicker} from 'antd';
import moment from 'moment';
import 'dayjs/locale/he';
import locale from "antd/es/date-picker/locale/he_IL";

const SelectDate = ({
                      onSave,
                      onCancel,
                      onChange,
                      value,
                      saveOnBlur = true,
                      ...rest
                    }) => {
  useEffect(() => {
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  const handleKeyUp = event => {
    if (event.key === 'Escape' && onCancel) {
      onCancel();
    }
  };

  const defaultState = value
    ? moment(value, 'DD.MM.YYYY').toDate()
    : moment().toDate();
  const [selected, setSelected] = useState(defaultState);
  const handleBlur = () => {
    if (saveOnBlur && selected && onSave) {
      onSave(Date.parse(moment(selected).format('YYYY-MM-DD')));
    }
  };

  const handleChange = date => {
    setSelected(date);
    if (onChange) {
      onChange(date)
    }
  };

  return (
  <DatePicker
    className="form-control d-flex"
    onChange={(date) => {
      if (date.$d) {
        handleChange(date.$d)
      }
    }}
    onBlur={handleBlur}
    locale={locale}
    format={'DD-MM-YYYY'}
    suffixIcon={false}
    showToday={false}
    {...rest}
  />
  );
};

export default SelectDate;

